import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button, ButtonToolbar, DropdownButton, MenuItem} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {
  TextInput,
  TextArea,
  DatePicker,
  RadioList,
  FileUpload,
  ImageUpload,
  Select,
  Checkbox,
  ToggleButton,
  Number
} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import ClientLookup from '../../components/Form/ClientLookup';
import UserLookup from '../../components/Form/UserLookup';
import TrainerLookup from '../../components/Form/TrainerLookup';
import moment from 'moment';
import Client from '../../helpers/ApiClient';
import {ModalWindow} from 'reactis-modal';
import DriverList from '../../containers/Driver/PickerList';
import DriverForm from '../../containers/Driver/Form';
import TrainingtextList from '../../containers/Trainingtext/PickerList';
import ProgrammeList from '../../containers/Programme/PickerList';
import TrainingList from '../../containers/Training/PickerList';
import Renderers from '../../helpers/Renderers';
import immutable from 'immutable';
import * as tabActions from '../../redux/modules/tabs';
import ReasonList from '../../containers/Reason/PickerList';
import OutroList from '../../containers/Outro/PickerList';
import PraxeList from '../../containers/Praxe/PickerList';
import VehicleLookup from "../../components/Form/VehicleLookup";
import TrainingTypeSelect from "../../components/Form/TrainingTypeSelect";
import DriverSubform from "./DriverSubform";
import DriverSubformFail from "./DriverSubformFail";
import DocumentSubform from "../../containers/Document/DocumentSubform";
import DocumentList from "../../containers/Document/PickerList";
import GroupsInput from '../../components/Form/GroupsInput';

class TrainingSubform extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      overRemove: false
    }
  }

  handleMouseOver() {
    this.setState({overRemove: true});
  }

  handleMouseOut() {
    this.setState({overRemove: false});
  }

  render() {
    return (
      <tr className={this.state.overRemove ? 'subformOverRemove' : null}>
        <td><FormField name="type"/></td>
        <td><i title="Odstranit"
               onClick={this.props.onRemove}
               onMouseOver={() => this.handleMouseOver()}
               onMouseOut={() => this.handleMouseOut()}
               className="icon-cross removesubform"/>
        </td>
      </tr>
    )
  }
}

@connect((state, props) => {
    return {
      form: state.forms.get('tab_' + props.tabid),
      user: state.auth.identity
    };
  },
  (dispatch) => {
    return {actions: bindActionCreators(formactions, dispatch)};
  }, null, {withRef: true})
export default class Form extends FormDB {

  constructor(props, context) {
    super(props, context);

    this.api = {
      fetch: 'training.fetch',
      save: 'training.save',
      remove: 'training.delete'
    };

    this.changeEvent = 'training.change';

    this.messages = {
      remove: 'Opravdu si přejete školení odstranit?',
      notfound: 'Školení nenalezeno!'
    };

    this.schema = {
      number: {
        class: TextInput,
        label: 'Protokol č.',
        style: {width: 50},
        rules: {
          presence: {message: 'Protokol je povinná položka!'}
        }
      },
      year: {
        class: TextInput,
        label: 'Rok',
        style: {width: 60},
        rules: {
          presence: {message: 'Protokol je povinná položka!'}
        }
      },
      client: {
        class: ClientLookup,
        addButton: true,
        label: 'Firma'
        /*rules: {
          presence: {message: 'Firma je povinná položka!'}
        }*/
      },
      type: {
        class: TrainingTypeSelect,
        label: 'Druh školení',
        rules: {
          presence: {message: 'Druh školení je povinná položka!'}
        },
        onChange: (value) => {
          const item = DbInfo.TrainingType(context.store).getItem(value);
          this.form.setValue({programme: item.programme, text: item.text});
        }
      },
      duration: {
        class: Select,
        options: DbInfo.TrainingDuration,
        label: 'Platnost',
        clearable: false,
        value: 1
      },
      date_from: {
        class: DatePicker,
        width: 100,
        value: new moment().format('YYYY-MM-DD'),
        label: 'Datum od'
      },
      date_to: {
        class: DatePicker,
        width: 100,
        value: new moment().format('YYYY-MM-DD'),
        label: 'Datum do'
      },
      /*user: {
        class: UserLookup,
        addButton: true,
        label: 'Školení provedl',
        value: {id: this.props.user.id, text: this.props.user.surname + ' ' + this.props.user.name}
      },*/
      trainer: {
        class: TrainerLookup,
        label: 'Školení provedl',
      },
      e: {
        class: RadioList,
        options: DbInfo.YesNo,
        label: 'E-školení',
        value: 0
      },
      praxe_date_from: {
        class: DatePicker,
        width: 100,
        label: 'Datum od'
      },
      praxe_date_to: {
        class: DatePicker,
        width: 100,
        label: 'Datum do'
      },
      trainer_praxe: {
        class: TrainerLookup,
        label: 'Praktický zácvik provedl',
      },
      trainer_verify: {
        class: TrainerLookup,
        label: 'Ověření provedl',
      },
      /*user_praxe_text: {
        class: TextInput,
        label: 'Praktický zácvik provedl'
      },
      user_verify: {
        class: TextInput,
        label: 'Ověření provedl'
      },*/
      programme: {
        class: TextArea,
        label: 'Program školení',
        style: {
          height: 200
        }
      },
      text: {
        class: TextArea,
        label: 'Zvl. bod',
        style: {
          height: 100
        }
      },
      praxe: {
        class: TextArea,
        label: 'Praktické dovednosti',
        style: {
          height: 70
        }
      },
      outro: {
        class: TextArea,
        label: 'Závěr',
        style: {
          height: 70
        }
      },
      fails: {
        class: Multiform,
        className: 'drivers multiform',
        label: 'Účastníci',
        addLabel: false,
        subform: DriverSubformFail,
        schema: {
          surname: {
            class: TextInput,
            label: 'Příjmení'
          },
          name: {
            class: TextInput,
            label: 'Jméno'
          },
          born: {
            class: TextInput,
            label: 'Dat. nar.'
          },
        }
      },
      reason: {
        class: TextArea,
        label: 'Odůvodnění',
        style: {
          height: 70
        }
      },
      /*result: {
          class: TextArea,
          label: 'Zvl. bod',
          style: {
              height: 70
          }
      },*/
      notice: {
        class: TextInput,
        label: 'Poznámka'
      },
      files: {
        class: FileUpload,
        label: 'Přílohy'
      },
      e_status: {
        class: Select,
        options: DbInfo.ETrainingStatus,
        label: 'Stav e-školení',
        clearable: false,
        value: 1,
        visible: (data) => {
          return data.e
        }
      },
      documents: {
        class: Multiform,
        className: 'drivers multiform',
        label: 'Studijní materiály',
        addLabel: false,
        showHeader: false,
        subform: DocumentSubform,
        visible: (data) => {
          return data.e
        },
        schema: {
          title: {
            class: TextInput,
            label: 'Název'
          }
        }
      },
      drivers: {
        class: Multiform,
        className: 'drivers multiform',
        label: 'Účastníci',
        addLabel: false,
        subform: DriverSubform,
        schema: {
          surname: {
            class: TextInput,
            label: 'Příjmení'
          },
          name: {
            class: TextInput,
            label: 'Jméno'
          },
          born: {
            class: TextInput,
            label: 'Dat. nar.'
          },
          groups1: {
            class: GroupsInput,
            label: 'Opravnění'
          },
          groups2: {
            class: GroupsInput,
          },
          ex_groups1: {
            class: GroupsInput,
            label: 'Rozšíření'
          },
          ex_groups2: {
            class: GroupsInput,
          },
          groups_z_text: {
            class: TextArea,
            style: {height: 30},
          },
          ex_groups_z_text: {
            class: TextArea,
            style: {height: 30},
          },
        }
      },
      op_a: {
        class: ToggleButton,
        title: 'A',
      },
      op_b: {
        class: ToggleButton,
        title: 'B',
      },
      op_c: {
        class: ToggleButton,
        title: 'C',
      },
      op_d: {
        class: ToggleButton,
        title: 'D',
      },
      op_e: {
        class: ToggleButton,
        title: 'E',
      },
      op_f: {
        class: ToggleButton,
        title: 'F',
      },
      op_g: {
        class: ToggleButton,
        title: 'G',
      },
      op_w1: {
        class: ToggleButton,
        title: 'W1',
      },
      op_w2: {
        class: ToggleButton,
        title: 'W2',
      },
      op_m: {
        class: ToggleButton,
        title: 'M',
      },
      op_z: {
        class: ToggleButton,
        title: 'Z',
      },

      op_a_2: {
        class: ToggleButton,
        title: 'A',
      },
      op_b_2: {
        class: ToggleButton,
        title: 'B',
      },
      op_c_2: {
        class: ToggleButton,
        title: 'C',
      },
      op_d_2: {
        class: ToggleButton,
        title: 'D',
      },
      op_e_2: {
        class: ToggleButton,
        title: 'E',
      },
      op_f_2: {
        class: ToggleButton,
        title: 'F',
      },
      op_g_2: {
        class: ToggleButton,
        title: 'G',
      },
      op_w1_2: {
        class: ToggleButton,
        title: 'W1',
      },
      op_w2_2: {
        class: ToggleButton,
        title: 'W2',
      },
      op_m_2: {
        class: ToggleButton,
        title: 'M',
      },
      op_z_2: {
        class: ToggleButton,
        title: 'Z',
      },
    };
    this.form = new FormManager(this.schema);
    if (!this.props.id) {
      const client = new Client();
      client.call('training.getDefaults').then((data) => {
        this.form.setValue(data);
      });
    }
  }

  componentDidMount() {
    this.form.on('change', (key, value, values) => {
      if (key == 'number' || key == 'year') {
        this.updateTab(values.toJS());
      }
      this.changed = true;
    });
    super.componentDidMount();
  }

  updateTab(data) {
    this.props.updateTab({title: data.number + '/' + data.year});
  }

  handleAddDocument(document) {
    let documents = this.form.getValues().get('documents');
    if (!documents) {
      documents = immutable.List();
    }
    documents = documents.push({
      id: -Math.random(),
      document: document.id,
      title: document.title,
      fTitle: document.fTitle
    });
    this.form.setValue({documents: documents.toJS()});
  }

  pickDocuments() {
    this.popupDriver = new ModalWindow(null, <DocumentList onAdd={(document) => this.handleAddDocument(document)}/>);
    this.popupDriver.className = 'wide950';
    this.popupDriver.show(this.context.store.dispatch);
  }

  pickText(input = 'text') {
    this.popupText = new ModalWindow(null, <TrainingtextList onSelect={(text) => this.handleAddText(text, input)}/>);
    this.popupText.className = 'wide900';
    this.popupText.show(this.context.store.dispatch);
  }

  pickReason() {
    this.popupText = new ModalWindow(null, <ReasonList onSelect={(text) => this.handleSelectText(text, 'reason')}/>);
    this.popupText.className = 'wide900';
    this.popupText.show(this.context.store.dispatch);
  }

  pickOutro() {
    this.popupText = new ModalWindow(null, <OutroList onSelect={(text) => this.handleSelectText(text, 'outro')}/>);
    this.popupText.className = 'wide900';
    this.popupText.show(this.context.store.dispatch);
  }

  pickPraxe() {
    this.popupText = new ModalWindow(null, <PraxeList onSelect={(text) => this.handleSelectText(text, 'praxe')}/>);
    this.popupText.className = 'wide900';
    this.popupText.show(this.context.store.dispatch);
  }

  pickProgramme() {
    this.popupText = new ModalWindow(null, <ProgrammeList onSelect={(text) => this.handleSelectProgramme(text)}/>);
    this.popupText.className = 'wide600';
    this.popupText.show(this.context.store.dispatch);
  }

  pickTraining() {
    let firm = this.form.getValues().getIn(['client', 'text']);
    this.popupTraining = new ModalWindow(null, <TrainingList firm={firm}
                                                             onSelect={(id) => this.handleSelectTraining(id)}/>);
    this.popupTraining.className = 'wide950';
    this.popupTraining.show(this.context.store.dispatch);
  }

  handleSelectText(text, input) {
    const o = {};
    o[input] = text;
    this.form.setValue(o);
    this.popupText.hide();
  }

  handleAddText(text, input) {
    const o = {};
    const v = this.form.getValues().get(input);
    o[input] = (v ? v + "\n" : '') + text;
    this.form.setValue(o);
    this.popupText.hide();
  }


  handleSelectProgramme(text) {
    this.form.setValue({programme: text});
    this.popupText.hide();
  }

  handleSelectTraining(id) {
    this.popupTraining.hide();
    const client = new Client();
    client.call('training.fetch', {id}).then((data) => {
      data.form.drivers.forEach((item) => {
        this.handleAddDriver({
          id: item.driver,
          name: item.name,
          surname: item.surname,
          born: item.born,
          groups1: item.driver_groups1,
          groups2: item.driver_groups2,
        });
      });
    });
  }

  handleNewDriver() {
    let firm = this.form.getValues().get('client');
    this.newDriver = new ModalWindow('Nový řidič', <DriverForm firm={firm ? firm.toJS() : null} popup={true}
                                                               onClose={() => this.handleHideNewDriver()}
                                                               onSave={(driver) => this.handleSaveDriver(driver)}/>);
    this.newDriver.className = 'wide950';
    this.newDriver.show(this.context.store.dispatch);
  }

  handleHideNewDriver() {
    this.newDriver.hide();
  }

  pickDriver(type = 1) {
    let firm = this.form.getValues().getIn(['client', 'text']);
    this.popupDriver = new ModalWindow(null, <DriverList firm={firm}
                                                         onAdd={(text) => this.handleAddDriver(text, type)}/>);
    this.popupDriver.className = 'wide950';
    this.popupDriver.show(this.context.store.dispatch);
  }

  handleSaveDriver(driver) {
    this.handleHideNewDriver();
    const gs2arr = (gs) => {
      const opFormat = JSON.parse(gs)
      const arr = []
      Object.keys(opFormat).forEach((key) => {
        let k = key.replace('op_', '')
        if (opFormat[key]) {
          arr.push(k)
        }
      })
      return arr
    }
    driver.groups1 = gs2arr(driver.groups1)
    driver.groups2 = gs2arr(driver.groups2)
    this.handleAddDriver(driver);
  }

  handleAddDriver(driver, type = 1) {
    console.log(driver)

    const arr2groups = (arr) => {
      const res = {}
      arr.forEach((item) => {
        res[item] = true;
      });
      return res
    }

    if (type == 1) {
      let drivers = this.form.getValues().get('drivers');
      if (!drivers) {
        drivers = immutable.List();
      }
      drivers = drivers.push({
        id: -Math.random(),
        driver: driver.id,
        name: driver.name,
        surname: driver.surname,
        born: driver.born,
        groups1: arr2groups(driver.groups1),
        groups2: arr2groups(driver.groups2),
        ex_groups1: {},
        ex_groups2: {},
      });
      this.form.setValue({drivers: drivers.toJS()});
    } else {
      let drivers = this.form.getValues().get('fails');
      if (!drivers) {
        drivers = immutable.List();
      }
      drivers = drivers.push({
        id: -Math.random(),
        driver: driver.id,
        name: driver.name,
        surname: driver.surname,
        born: driver.born,
        groups1: {},
        groups2: {},
        ex_groups1: {},
        ex_groups2: {},
        //groups: driver.op
      });
      this.form.setValue({fails: drivers.toJS()});
    }
  }

  handlePrint(type) {
    const api = new Client();
    api.call('training.download', {id: this.props.id, type}, {progress: true}).then((data) => {
      if (data) {
        var win = window.open(data.url, '_blank');
        if (win) {
          win.focus();
        } else {
          alert('Povolte prosím v prohlížeči vyskakovací okna pro tuto aplikaci.');
        }
        //window.location = data.url;
      }
    });
  };

  render() {
    const data = this.props.form && this.props.form.get('data') ? this.props.form.get('data').toJS() : {};
    const canEdit = true;
    const saveButton = <SaveButton
      disabled={!canEdit}
      loading={!!(this.props.form && this.props.form.get('saving'))}
      onClick={() => this.save()}
    />;

    const printButton = (
      <DropdownButton id="print" style={{marginLeft: 5}} bsStyle="success"
                      title={<span><i className="fa fa-print  position-left"/>Tisk</span>}>
        <MenuItem onSelect={() => this.handlePrint(1)} eventKey="1">Záznam o školení</MenuItem>
        {data.e &&
          <MenuItem onSelect={() => this.handlePrint(8)} eventKey="1">Záznam o elektronickém školení</MenuItem>}
        {data.e &&
          <MenuItem onSelect={() => this.handlePrint(10)} eventKey="10">Záznam o elektronických testech</MenuItem>}
        <MenuItem onSelect={() => this.handlePrint(2)} eventKey="2">Protokol k záznamu o školení</MenuItem>
        <MenuItem onSelect={() => this.handlePrint(3)} eventKey="3">Záznam o praktickém zácviku</MenuItem>
        <MenuItem onSelect={() => this.handlePrint(9)} eventKey="3">Záznam o praktickém zácviku (e-školení)</MenuItem>
        <MenuItem onSelect={() => this.handlePrint(4)} eventKey="4">Evidenční listy</MenuItem>
        <MenuItem onSelect={() => this.handlePrint(5)} eventKey="5">Průkazy EU</MenuItem>
        <MenuItem onSelect={() => this.handlePrint(7)} eventKey="7">Průkazy podnikové</MenuItem>
        <MenuItem onSelect={() => this.handlePrint(6)} eventKey="6">Potvrzení o opakovaném školení</MenuItem>
      </DropdownButton>
    );

    const emailButton = (
      <DropdownButton id="print" style={{marginLeft: 5}} bsStyle="success"
                      title={<span><i className="fa fa-envelope-o position-left"/>Poslat e-mailem</span>}>
        <MenuItem onSelect={() => this.handlePrint(1)} eventKey="1">Prezenční listina</MenuItem>
        <MenuItem onSelect={() => this.handlePrint(2)} eventKey="2">Záznam o praktickém výcviku</MenuItem>
      </DropdownButton>
    );

    const btns = <ButtonToolbar>
      {saveButton}
      {this.props.id > 0 &&
        <ActionButton disabled={!canEdit} bsStyle="danger" icon="fa fa-trash-o" onClick={() => this.remove()}>
          Odstranit
        </ActionButton>}
      {this.props.id > 0 && printButton}
    </ButtonToolbar>;


    return (
      <div style={{position: 'relative'}}>
        <Loader visible={!!(this.props.form && this.props.form.get('loading'))}/>
        <RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
          <Toolbar title="Školení" buttons={btns}/>
          <div className="row">
            <div className="col-xs-11">
              <table className="form">
                <tbody>
                <FormRow label="Protokol č." labelWidth={160}>
                  <FormField name="number"/> / <FormField name="year"/>
                </FormRow>
                <FormRow name="client"/>
                <FormRow label="Účastníci">
                  <FormField name="drivers"/>
                  <ButtonToolbar style={{float: 'none', margin: '10px 0px'}}>
                    <Button onClick={() => this.handleNewDriver()}><span className="fa fa-plus position-left"></span>nový
                      řidič</Button>
                    <Button onClick={() => this.pickDriver()}><span
                      className="fa fa-hand-pointer-o position-left"></span>vybrat z evidence</Button>
                    <Button onClick={() => this.pickTraining()}><span
                      className="fa fa-file-text-o position-left"></span>kopírovat ze školení</Button>
                  </ButtonToolbar>
                </FormRow>
                <FormRow label="Datum od">
                  <table style={{margin: -4}}>
                    <tbody>
                    <tr>
                      <td>
                        <FormField name="date_from"/> do <FormField name="date_to"/>
                      </td>
                      <td>
                        platnost
                      </td>
                      <td style={{width: 100}}>
                        <FormField name="duration"/>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </FormRow>
                <FormRow name="type"/>
                <FormRow name="e"/>
                <FormRow name="e_status" visible={this.schema.e_status.visible}/>
                <FormRow label="Studijní materiály" visible={this.schema.documents.visible}>
                  <FormField name="documents"/>
                  <Button onClick={() => this.pickDocuments()}><span
                    className="fa fa-hand-pointer-o position-left"></span>vybrat z dokumentů</Button>
                </FormRow>
                {this.form.getValues().get('e') > 0 && <tr>
                  <th>Skupiny I.</th>
                  <td className="toggles">
                    <FormField name="op_a"/> <FormField name="op_b"/> <FormField name="op_c"/> <FormField name="op_d"/>
                    <FormField name="op_e"/> <FormField name="op_f"/> <FormField name="op_g"/> <FormField name="op_w1"/>
                    <FormField name="op_w2"/> <FormField name="op_m"/> <FormField name="op_z"/>
                  </td>
                </tr>}
                {this.form.getValues().get('e') > 0 && <tr>
                  <th>Skupiny II.</th>
                  <td className="toggles">
                    <FormField name="op_a_2"/> <FormField name="op_b_2"/> <FormField name="op_c_2"/> <FormField
                    name="op_d_2"/> <FormField name="op_e_2"/> <FormField name="op_f_2"/> <FormField name="op_g_2"/>
                    <FormField name="op_w1_2"/> <FormField name="op_w2_2"/> <FormField name="op_m_2"/> <FormField
                    name="op_z_2"/>
                  </td>
                </tr>}

                {data.e &&
                  <tr>
                    <th style={{width: 170}}>Prohlášení o porozumění</th>
                    <td>{data.e_agreebutton}</td>
                  </tr>}

                {data.e_praxe_date &&
                  <tr>
                    <th style={{width: 170}}>Objednávka na PZ</th>
                    <td>{data.e_praxe_date} {data.e_praxe_hour} {data.e_praxe_notice}</td>
                  </tr>}
                <FormRow name="trainer"/>
                <FormRow label="Praktický zácvik">
                  <table style={{margin: -4}}>
                    <tbody>
                    <tr>
                      <td>
                        <FormField name="praxe_date_from"/> do <FormField name="praxe_date_to"/>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </FormRow>
                <FormRow name="trainer_praxe"/>
                <FormRow name="trainer_verify"/>
                <FormRow label="Program školení">
                  <table style={{width: '100%'}}>
                    <tbody>
                    <tr>
                      <td>
                        <FormField name="programme"/>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </FormRow>
                <FormRow label="Zvl. bod">
                  <table style={{width: '100%'}}>
                    <tbody>
                    <tr>
                      <td>
                        <FormField name="text"/>
                      </td>
                      <td style={{width: 100, verticalAlign: 'top'}}>
                        <Button onClick={() => this.pickText()}><span
                          className="fa fa-hand-pointer-o position-left"></span>vybrat</Button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </FormRow>


                </tbody>
              </table>


              <fieldset>
                <legend>Výsledek</legend>
              </fieldset>
              <table className="form">
                <tbody>
                <FormRow label="Praktické dovednosti" labelWidth={160}>
                  <table style={{width: '100%'}}>
                    <tbody>
                    <tr>
                      <td>
                        <FormField name="praxe"/>
                      </td>
                      <td style={{width: 100, verticalAlign: 'top'}}>
                        <Button onClick={() => this.pickPraxe()}><span
                          className="fa fa-hand-pointer-o position-left"></span>vybrat</Button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </FormRow>
                <FormRow label="Závěr">
                  <table style={{width: '100%'}}>
                    <tbody>
                    <tr>
                      <td>
                        <FormField name="outro"/>
                      </td>
                      <td style={{width: 100, verticalAlign: 'top'}}>
                        <Button onClick={() => this.pickOutro()}><span
                          className="fa fa-hand-pointer-o position-left"></span>vybrat</Button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </FormRow>
                <FormRow label="Nesplňující účastníci">
                  <FormField name="fails"/>
                  <ButtonToolbar style={{float: 'none', margin: '10px 0px'}}>
                    <Button onClick={() => this.pickDriver(2)}><span
                      className="fa fa-hand-pointer-o position-left"></span>vybrat z evidence</Button>
                  </ButtonToolbar>
                </FormRow>
                <FormRow label="Odůvodnění">
                  <table style={{width: '100%'}}>
                    <tbody>
                    <tr>
                      <td>
                        <FormField name="reason"/>
                      </td>
                      <td style={{width: 100, verticalAlign: 'top'}}>
                        <Button onClick={() => this.pickReason()}><span
                          className="fa fa-hand-pointer-o position-left"></span>vybrat</Button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </FormRow>
                <FormRow name="files"/>
                </tbody>
              </table>

              {data.e &&
                <div>
                  <fieldset>
                    <legend>Testy</legend>
                  </fieldset>
                  <table className="form">
                    <tbody>
                    {data.tests && data.tests.map((item, key) => {
                      return <tr key={key}>
                        <th style={{width: 180, verticalAlign: 'top'}}>
                          {item.title}<br/>
                          <div style={{fontWeight: 'normal'}}>
                            začátek: {Renderers.DateTime(item.start)}<br/>
                            konec: {Renderers.DateTime(item.finish)}<br/>
                            max. bodů: {item.points}<br/>
                            {item.points_correct && <span>dosaženo bodů: {item.points_correct}<br/></span>}
                            {item.statusText}<br/>
                          </div>
                        </th>
                        <td>
                          {item.questions.map((q, index) => {
                            let color = '#777';
                            if (q.answered) {
                              if (q.correct) {
                                color = '#090'
                              } else {
                                color = '#A00'
                              }
                            }
                            return <div style={{color: color}}>{index + 1}. {q.title} [{q.points} b]</div>;
                          })}
                        </td>
                      </tr>
                    })}
                    </tbody>
                  </table>
                </div>}
            </div>
          </div>
        </RxForm>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Training/Form.js